(($, Drupal) => {
  Drupal.behaviors.allShops = {
    attach: function attach() {
      $('.all-shops').once('add').each(function (index) {
        const filtersElements = this.querySelectorAll('.shop-page__filters .sort [data-drupal-selector="edit-sort-by"] input');
        if (filtersElements.length) {
          window.shopValue = filtersElements[0].value;
        }
      });

      $('.shop-page__filters').once('add').each(function (index) {
        const _self = this;
        const filtersElements = _self.querySelectorAll('.sort [data-drupal-selector="edit-sort-by"] input');

        if (!filtersElements.length) return false;

        filtersElements.forEach((element) => {
          element.onclick = function () {
            const thisValue = this.value;
            const filtersOrderContainer = _self.querySelector('.sort [data-drupal-selector="edit-sort-order"] .form-radios');
            const ascButton = filtersOrderContainer.querySelector('input[value="ASC"]');
            const descButton = filtersOrderContainer.querySelector('input[value="DESC"]');

            if (ascButton.checked && window.shopValue === thisValue) {
              descButton.click();
            }

            if (descButton.checked && window.shopValue === thisValue) {
              ascButton.click();
            }

            window.shopValue = thisValue;
          };
        });
      });

      $('.categories-parent.have-children').once('add').each(function (index) {
        const _self = this;
        const triggerElem = _self.querySelector('.square');
        const TOGGLE_CLASS = 'open';

        if (!triggerElem) return false;

        triggerElem.addEventListener('click', function () {
          const parentElems = this.closest('.views-row');

          if (!parentElems) return false;

          const listElem = parentElems.querySelector('.categories-child');
          this.classList.toggle(TOGGLE_CLASS);
          listElem.classList.toggle(TOGGLE_CLASS);
        });
      });
    },
  };
})(jQuery, Drupal);
